// EhrOAuthEndpoint redirects here with these two params when a third party app is asking
//   for a patient's records. A plain portal sign in carries neither.
//   See OAuth2ErrorHelper.CreateLoginResponseUri in that service.
const REQUIRED_PARAMS = ['sessionId', 'clientId'];

export const isAppAuthorizationRequest = (search) => {
    const params = new URLSearchParams(search || '');

    return REQUIRED_PARAMS.every(name => Boolean(params.get(name)));
};
